/**
 * 
 */
export class FormValidation {

    public static RFC_FISICO = /^([A-ZÑ]{4}|[A-Z][AEIOU][A-Z]{2})\d{2}((01|03|05|07|08|10|12)(0[1-9]|[12]\d|3[01])|02(0[1-9]|[12]\d)|(04|06|09|11)(0[1-9]|[12]\d|30))([A-Z0-9]{3})$/i;
    public static RFC_MORAL = /^([A-Z&Ñ]{3})\d{2}((01|03|05|07|08|10|12)(0[1-9]|[12]\d|3[01])|02(0[1-9]|[12]\d)|(04|06|09|11)(0[1-9]|[12]\d|30))([A-Z0-9]{3})$/i;
    public static CURP = /^[A-ZÑ][A,E,I,O,U,X][A-ZÑ]{2}[0-9]{2}[0-1][0-9][0-3][0-9][M,H][A-Z]{2}[B,C,D,F,G,H,J,K,L,M,N,Ñ,P,Q,R,S,T,V,W,X,Y,Z]{3}[0-9,A-Z][0-9]$/i;
    public static EMAIL = /^[a-zA-Z0-9.!#$%&' * +/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9]{1}(?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/i;
    public static EMPLOYER_REGISTRATION_NUMBER = /^([A-Za-z]{1}[0-9]{10})$/i;
    public static NUMERICO = /^[0-9]+$/i;
    public static DECIMAL = /^-?[0-9]+([,\.][0-9]*)?$/i;

    private valor: string;
    public error: boolean;
    public mensaje: string;

    constructor(valor: any) {

        this.error = false;

        if (valor != null) {
            this.valor = String(valor);
        }
    }

    /**
     * 
     * @param message
     */
    public requered(message: string): FormValidation {

        if ((this.valor == null || this.valor.toString().trim().length == 0)) {
            this.error = true;
            this.mensaje = message;
        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public physicalRFC(message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = FormValidation.RFC_FISICO.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {

            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }

        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public moralRFC(message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = FormValidation.RFC_MORAL.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public curp(message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = FormValidation.CURP.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public emailAddress(message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = FormValidation.EMAIL.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public employerRegistrationNumber(message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = FormValidation.EMPLOYER_REGISTRATION_NUMBER.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param min
     * @param max
     * @param message
     */
    public stringLength(min: number, max: number, message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            if ((this.valor.trim().length < min) && !this.error) {
                this.error = true;
                this.mensaje = message;
            }

            if ((this.valor.trim().length > max) && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param regexp
     * @param message
     */
    public regexp(regexp: RegExp, message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = regexp.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public integer(message: string): FormValidation {

        console.log('integer -->> ')

        if (this.valor != null && this.valor.toString().trim().length > 0) {

            let result = FormValidation.NUMERICO.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param message
     */
    public decimal(message: string): FormValidation {

        console.log('decimal -->> ')

        if (this.valor != null && this.valor.trim().length > 0) {

            let result = FormValidation.DECIMAL.test(this.valor);

            if (!result && !this.error) {
                this.error = true;
                this.mensaje = message;
            }
        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

    /**
     * 
     * @param min
     * @param max
     * @param message
     */
    public between(min: number, max: number, message: string): FormValidation {

        if (this.valor != null && this.valor.trim().length > 0) {

            let value: number = Number(this.valor);

            if (!(value >= min && value <= max) && !this.error) {
                this.error = true;
                this.mensaje = message;
            }

        } else {
            if (!this.error) {
                this.error = true;
                this.mensaje = message;
            }
        }

        return this;
    }

}